import angular from "angular";
import { directiveFactory } from "../angular-core";
import { FileDownloadService } from "@topline/services/fileDownloadService";
import ng from "angular";

export class TableExcelExportDirective implements ng.IDirective {
    static componentName: string = "tableExcelExport";
    static $inject = [FileDownloadService.componentName];
    restrict = "E";
    template = '<button> {{"EXPORT" | translate }} </button>';

    constructor(protected fileDownloadService: FileDownloadService) {}

    link = (scope: ng.IScope, element: JQLite, attr: ng.IAttributes) => {
        element.bind("click", () => {
            var tableElement = angular.element(document.getElementById(attr.tableId)!);

            var columns = [];

            for (const columnElement of angular.element(tableElement).find("thead th")) {
                columns.push(angular.element(columnElement).text().trim());
            }

            var rows = [];

            for (const rowElement of angular.element(tableElement).find("tbody tr")) {
                var row: { header?: string; values: string[] } = {
                    header: undefined,
                    values: []
                };

                for (const valueElement of angular.element(rowElement).find("th")) {
                    row.header = angular.element(valueElement).text().trim();
                }

                for (const valueElement of angular.element(rowElement).find("td")) {
                    row.values.push(angular.element(valueElement).text().trim());
                }
                rows.push(row);
            }
            this.fileDownloadService.exportTable("table.xlsx", {
                columns: columns,
                rows: rows
            });
        });
    };
}

angular
    .module("topline.directives")
    .directive(TableExcelExportDirective.componentName, directiveFactory(TableExcelExportDirective));
